export default __webpack_public_path__ + "static/media/bayw.c840b754.png";